<template>
    <div class="orderTab-bottom">
        <div class="topMazimize d-flex align-items-center border-bottom justify-content-between" v-if="$route.name == 'custom-view'">
            <p>{{$t('trade_history')}}</p>
            <div class="justify-content-end">
                <a href="javascript:void(0)" @click.prevent="$parent.$parent.maximize('history')"><feather size="12px" type="maximize-2"></feather></a>
                <a href="javascript:void(0)" @click.prevent="$parent.$parent.close('history')"><feather size="12px" type="x"></feather></a>
            </div>
        </div>
        <app-custom-time v-if="customTime" @changeTime="dateSelected = '';changeTime()"></app-custom-time>
        <div class="topHead border-bottom d-flex justify-content-between align-items-center">
            <tab-section :order="order"/>
            <div class="arrowToggle d-flex align-items-center">
                <!-- <a @click="$parent.$parent.setUpFxaccount = !$parent.$parent.setUpFxaccount" class="arrowToggle-buton mr-3" href="javascript:void(0)" v-if="$route.name == 'multi-view'"><feather size="15px" type="chevron-up"></feather> </a> -->
                <a href="javascript:void(0)" class="arrowToggle-buton mr-3">{{$t('p_slash_l')}} : <span :class="{'red':p_l < 0, 'green':p_l > 0 }">{{formatCurrency((p_l || 0), accountList.Currency)}}</span></a>
                <div class="filterOption position-relative d-flex align-items-center">
                    <a href="javascript:void(0)" class="appButton statusChange" @click="status =!status">
                        <span>{{(parseInt(tradeType) == 1)?'Completed':(parseInt(tradeType) == 2)?'Rejected':'Pending Closed'}}</span>
                        <feather class="ml-1" size="12px" type="chevron-down"></feather>
                    </a>
                    <div class="custonDropDown dropdown-menu" :class="status?'show':''" style="z-index: 9999;">
                        <ul class="statusCom">
                            <li class="mr-2">
                                <label class="customRadiobox mb-0">
                                    {{$t('completed')}}
                                    <input type="radio" v-model="tradeType" :value="'1'" @change="tradeTypeChange()"/>
                                    <span class="checkmark"></span>
                                </label>
                            </li>
                            <li class="mr-2">
                                <label class="customRadiobox mb-0">
                                    {{$t('rejected')}}
                                    <input type="radio" v-model="tradeType" :value="'2'" @change="tradeTypeChange()"/>
                                    <span class="checkmark"></span>
                                </label>
                            </li>
                            <li class="mr-2">
                                <label class="customRadiobox mb-0">
                                    {{$t('pending_closed')}}
                                    <input type="radio" v-model="tradeType" :value="'3'" @change="tradeTypeChange()"/>
                                    <span class="checkmark"></span>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
                <pagination :totalRecords="tradeHistoryList.length" :limit="pageLimit" :pageNo="page" :showRecords="false" v-if="order == 'history' && tradeType == '1' && tradeHistoryList.length > pageLimit"></pagination>
                <pagination :totalRecords="rejectedTradeList.length" :limit="pageLimit" :pageNo="page" :showRecords="false" v-if="order == 'history' && tradeType == '2' && rejectedTradeList.length > pageLimit"></pagination>
                <pagination :totalRecords="pendingTradeList.length" :limit="pageLimit" :pageNo="page" :showRecords="false" v-if="order == 'history' && tradeType == '3' && pendingTradeList.length > pageLimit"></pagination>
                <a @click="$parent.$parent.setUpFxaccount = !$parent.$parent.setUpFxaccount" class="arrowToggle-buton ml-3" href="#" v-if="$route.name == 'multi-view'"><feather size="15px" type="chevron-up"></feather> </a>
                <div class="position-relative filterOption">
                    <button type="button" title="Date Range" class="appButton-r d-flex align-items-center justify-content-between ml-2" @click.prevent="filterOption = !filterOption"><feather size="15px" type="filter"></feather></button>
                    <div class="custonDropDown dropdown-menu show" v-if="filterOption && customTime == false">
                        <ul>
                            <li v-for="list,key in dateList" class="p-0">
                                <label class="customRadiobox">{{list}}
                                    <input type="radio" name="radio" :value="key" v-model="dateSelected" @change="changeDate()">
                                    <span class="checkmark"></span>
                                </label>
                            </li>
                            <li class="customTime-btn customTime p-0">
                                <a @click.prevent="customTime = !customTime" href="javascript:void(0)" class="customTime">{{$t('custom')}}</a> 
                            </li>
                        </ul>
                    </div>
                </div>
                <button type="button" title="Maximize / Collapse" class="appButton-r d-flex align-items-center justify-content-between ml-2" @click="addRemBodyClass()" v-if="$route.name == 'home'">
                    <feather class="showMin" size="15px" type="maximize-2"></feather>
                    <feather class="showMax d-none" size="15px" type="minimize-2"></feather>
                </button>
                <button @click="exportCsv()" class="appButton-r d-flex align-items-center justify-content-between ml-2">
                    <feather size="15px" type="external-link"></feather>
                </button>
            </div>
        </div>
        <div class="responsiveTable scrollbar bottomTable fixedHead" v-if="order == 'history'">
            <!-- <app-loader v-if="pageLoader"/> -->
            <table class="table table-hover stickyHead">
                <thead class="border-0" v-if="(tradeType == '1' && tradeHistoryList.length > 0) || (tradeType == '2' && rejectedTradeList.length > 0) || (tradeType == '3' && pendingTradeList.length > 0)">
                    <tr>
                        <th v-if="rowSelected.includes('ID')">{{(tradeType == '1')?'Trade ID':'Order ID'}}</th>
                        <th v-if="rowSelected.includes('Open Time Date') && tradeType == '1'">{{$t('open_time')}}</th>
                        <th v-if="rowSelected.includes('Type')">{{$t('type')}}</th>
                        <th v-if="rowSelected.includes('Reason') && tradeType == '1'">{{$t('reason')}}</th>
                        <th v-if="rowSelected.includes('Lots')">{{(userSettings.position_size && userSettings.position_size == '1')?'Units':'Lots'}}</th>
                        <th v-if="rowSelected.includes('Instrument')">{{$t('instrument')}}</th>
                        <th v-if="rowSelected.includes('Open Price')">{{$t('open_price')}}</th>
                        <!-- <th v-if="rowSelected.includes('S/L')">S/L</th>
                        <th v-if="rowSelected.includes('T/P')">T/P</th> -->
                        <th v-if="rowSelected.includes('Close time date')">{{$t('close_time_date')}}</th>
                        <th v-if="rowSelected.includes('Close price')">{{$t('close_price')}}</th>
                        <th v-if="rowSelected.includes('Commission')">{{$t('commission')}}</th>
                        <th v-if="rowSelected.includes('Swap')">{{$t('swap')}}</th>
                        <th v-if="rowSelected.includes('Profit/loss')">{{$t('net_pl')}}</th>
                        <th v-if="rowSelected.includes('Status')">{{$t('status')}}</th>
                        <th v-if="rowSelected.includes('Comment')">{{$t('comment')}}</th>
                        <th align="right" class="addRowOption" :class="toggleButton?'active':''">
                            <a @click.prevent="toggleButton = !toggleButton" class="verticleDots" href="#">
                                <feather class="lt" type="more-vertical"></feather> 
                                <feather class="rt" type="x"></feather> 
                            </a>
                            <ul class="drop-down">
                                <!-- <div> -->
                                    <li v-for="item in rowsList">
                                        <label class="customCheckbox" v-if="!['Reason','Open Time Date'].includes(item) || tradeType == '1'">
                                            {{(item == 'ID')?((tradeType == '1')?'Trade ID':'Order I')
                                                :(item == 'Lots')?((userSettings.position_size && userSettings.position_size == '1')?'Units':'Lots')
                                                :item
                                            }}
                                            <input type="checkbox" v-model="rowSelected" :value="item" @change="saveLocal()">
                                            <span class="checkmark"></span>
                                        </label>
                                    </li>
                                <!-- </div> -->
                            </ul>
                        </th>
                        <!-- <th>Action</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="list,index in tradeHistoryList" v-if="tradeType == '1' && index >= (page - 1)*pageLimit && index < page*pageLimit">
                        <td v-if="rowSelected.includes('ID')">{{list.TradeID}}</td>
                        <!-- <td v-if="rowSelected.includes('Open Time Date')">{{list.OpenTime | moment('HH:mm:ss - DD-MM-YYYY')}}</td> -->
                        <td v-if="rowSelected.includes('Open Time Date')">{{formatDateTime(list.OpenTime)}}</td>
                        <td v-if="rowSelected.includes('Type')" :class="sideClass[list.Side]">{{sideValue[list.Side] || '-'}}</td>
                        <td v-if="rowSelected.includes('Reason')">{{reasonList[list.CloseOrderType] || '-'}}</td>
                        <td v-if="rowSelected.includes('Lots')">{{getQuantity(list) || '0'}}</td>
                        <td v-if="rowSelected.includes('Instrument')">{{list.Symbol}}</td>
                        <td v-if="rowSelected.includes('Open Price')">{{list.OpenPrice || '0'}}</td>
                        <!-- <td v-if="rowSelected.includes('S/L')">-</td>
                        <td v-if="rowSelected.includes('T/P')">-</td> -->
                        <!-- <td v-if="rowSelected.includes('Close time date')">{{list.CloseTime | moment('HH:mm:ss - DD-MM-YYYY')}}</td> -->
                        <td v-if="rowSelected.includes('Close time date')">{{ formatDateTime(list.CloseTime)}}</td>
                        <td v-if="rowSelected.includes('Close price')">{{list.ClosePrice || '0'}}</td>
                        <td v-if="rowSelected.includes('Commission')">{{formatCurrency((list.Commission || 0), accountList.Currency)}}</td>
                        <td v-if="rowSelected.includes('Swap')">{{formatCurrency((list.Interest || 0), accountList.Currency) }}</td>
                        <td v-if="rowSelected.includes('Profit/loss')" :class="[{'red': parseFloat(list.ProfitLoss - Math.abs(list.Commission || 0) + parseFloat(list.Interest) || 0) < 0 , 'green': parseFloat(list.ProfitLoss  - Math.abs(list.Commission || 0) + parseFloat(list.Interest) || 0) > 0 }]">
                            {{formatCurrency(parseFloat(list.ProfitLoss || 0) - Math.abs(list.Commission || 0) + parseFloat(list.Interest), accountList.Currency)}}
                        </td>
                        <td v-if="rowSelected.includes('Status')" class="green">{{$t('completed')}} </td>
                        <td v-if="rowSelected.includes('Comment')">{{list.Commentary || '-'}}</td>
                        <td>&nbsp;</td>
                        <!-- <td>
				        	<a class="td-button" href="#"><feather size="12px" type="edit"></feather></a>
				        	<a class="td-button" href="#"><feather size="12px" type="settings"></feather></a>
				        	<a class="td-button closeBtn" href="#"><feather size="12px" type="x"></feather></a>
				        </td> -->
                    </tr>
                    <tr v-if="tradeType == '1' && tradeHistoryList.length == 0">
                        <td class="noData border-0 h-100">
                            <app-loader v-if="pageLoader"/>
                            <no-data v-else text="No Completed Trades"/>
                        </td>
                    </tr>
                    <tr v-for="list,index in rejectedTradeList" v-if="tradeType == '2' && index >= (page - 1)*pageLimit && index < page*pageLimit">
                        <td v-if="rowSelected.includes('ID')">{{list.OrderID}}</td>
                        <!-- <td>-</td> -->
                        <td v-if="rowSelected.includes('Type')" :class="sideClass[list.Side]">{{sideValue[list.Side] || '-'}}</td>
                        <!-- <td v-if="rowSelected.includes('Reason')">{{reasonList[list.CloseOrderType] || '-'}}</td> -->
                        <td v-if="rowSelected.includes('Lots')">{{getQuantity(list) || '0'}}</td>
                        <td v-if="rowSelected.includes('Instrument')">{{list.Symbol}}</td>
                        <td v-if="rowSelected.includes('Open Price')">{{list.OpenPrice || '-'}}</td>
                        <!-- <td v-if="rowSelected.includes('S/L')">-</td>
                        <td v-if="rowSelected.includes('T/P')">-</td> -->
                        <!-- <td v-if="rowSelected.includes('Close time date')">{{list.RemoveTime | moment('HH:mm:ss - DD-MM-YYYY')}}</td> -->
                        <td v-if="rowSelected.includes('Close time date')">{{ formatDateTime(list.RemoveTime) }}</td>
                        <td v-if="rowSelected.includes('Close price')">{{list.ClosePrice || '-'}}</td>
                        <td v-if="rowSelected.includes('Commission')">{{list.Commission || '0'}}</td>
                        <td v-if="rowSelected.includes('Swap')">{{list.Interest || '0'}}</td>
                        <td v-if="rowSelected.includes('Profit/loss')" :class="[{'red': parseFloat(list.ProfitLoss + parseFloat(list.Interest) || 0) < 0 , 'green': parseFloat(list.ProfitLoss + parseFloat(list.Interest) || 0) > 0 }]">{{list.ProfitLoss + parseFloat(list.Interest) || '-'}}</td>
                        <td v-if="rowSelected.includes('Status')" class="red">{{$t('rejected')}}</td>
                        <td v-if="rowSelected.includes('Comment')">{{list.Commentary || '-'}}</td>
                        <td>&nbsp;</td>
                        <!-- <td>
                            <a class="td-button" href="#"><feather size="12px" type="edit"></feather></a>
                            <a class="td-button" href="#"><feather size="12px" type="settings"></feather></a>
                            <a class="td-button closeBtn" href="#"><feather size="12px" type="x"></feather></a>
                        </td> -->
                    </tr>
                    <tr v-if="tradeType == '2' && rejectedTradeList.length == 0">
                        <td class="noData border-0 h-100">
                            <app-loader v-if="pageLoader"/>
                            <no-data v-else text="No Rejected Orders"/>
                        </td>
                    </tr>
                    <tr v-for="list,index in pendingTradeList" v-if="tradeType == '3' && index >= (page - 1)*pageLimit && index < page*pageLimit">
                        <td v-if="rowSelected.includes('ID')">{{list.OrderID}}</td>
                        <!-- <td>-</td> -->
                        <!-- <td v-if="rowSelected.includes('Type')" :class="sideClass[list.Side]">{{sideValue[list.Side] || '-'}}</td> -->
                        <td v-if="rowSelected.includes('Type')" :class="sideClass[list.Side]">{{sideValue[list.Side] || '-'}} {{pendingType[list.Type] || '-'}}</td>
                        <!-- <td v-if="rowSelected.includes('Reason')">{{reasonList[list.CloseOrderType] || '-'}}</td> -->
                        <td v-if="rowSelected.includes('Lots')">{{ getQuantity(list) || '0' }}</td>
                        <td v-if="rowSelected.includes('Instrument')">{{list.Symbol}}</td>
                        <td v-if="rowSelected.includes('Open Price')">{{list.OpenPrice || '0'}}</td>
                        <!-- <td v-if="rowSelected.includes('S/L')">-</td>
                        <td v-if="rowSelected.includes('T/P')">-</td> -->
                        <!-- <td v-if="rowSelected.includes('Close time date')">{{list.RemoveTime | moment('HH:mm:ss - DD-MM-YYYY')}}</td> -->
                        <td v-if="rowSelected.includes('Close time date')">{{ formatDateTime(list.RemoveTime) }}</td>
                        <td v-if="rowSelected.includes('Close price')">{{list.ClosePrice || '0'}}</td>
                        <td v-if="rowSelected.includes('Commission')">{{list.Commission || '0'}}</td>
                        <td v-if="rowSelected.includes('Swap')">{{list.Interest || '0'}}</td>
                        <td v-if="rowSelected.includes('Profit/loss')" :class="[{'red': parseFloat(list.ProfitLoss || 0) < 0 , 'green': parseFloat(list.ProfitLoss || 0) > 0 }]">{{list.ProfitLoss || '0'}}</td>
                        <td v-if="rowSelected.includes('Status')" class="yellowDark">{{$t('pending_closed')}}</td>
                        <td v-if="rowSelected.includes('Comment')">{{list.Commentary || '-'}}</td>
                        <td>&nbsp;</td>
                        <!-- <td>
                            <a class="td-button" href="#"><feather size="12px" type="edit"></feather></a>
                            <a class="td-button" href="#"><feather size="12px" type="settings"></feather></a>
                            <a class="td-button closeBtn" href="#"><feather size="12px" type="x"></feather></a>
                        </td> -->
                    </tr>
                    <tr v-if="tradeType == '3' && pendingTradeList.length == 0">
                        <td class="noData border-0 h-100">
                            <app-loader v-if="pageLoader"/>
                            <no-data v-else text="No Pending Closed Orders"/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import app_custom_time from './app-custom-time'
    import tab_section from './tab-section'
    import { commonAllmixins } from '@/plugins/commonAll'
    import { Const } from '@/plugins/vue-provider-cache/const.mod'
    import moment from 'moment'
export default {
    name: 'history',
    mixins: [commonAllmixins],
    data() {
        return {
            pageLoader: false,
            page : '1',
            filterOption: false,
            customTime: false,
            toggleButton: false,
            status: false,
            sideClass:{
                '0':'red',
                '1':'green',
            },
            sideValue:{
                '0':'Sell',
                '1':'Buy',
            },
            pendingType:{
                'ES':'Stop',
                'EL':'limit',
                // 'S':'SL',
                // 'L':'TP'
                'S':'StopLoss',
                'L':'TakeProfit'
            },
            FROM_DATE : moment().subtract(1, 'months').format('YYYY-MM-DD'),
            TO_DATE : moment().format('YYYY-MM-DD'),
            currencyIcon : { EUR : "€", USD : "$", GBP : "£", CHF : "CHF", JPY : "¥", AUD: "$" },
            tradeType: '1',
            lastTrade : false,
            dateSelected:'',
            dateList:{ '1':'1 day', '2':'15 days', '3':'1 Month', '4':'6 Months' },
            rowsList:[ 'ID', 'Open Time Date', 'Type',"Reason",'Lots', 'Instrument', 'Open Price',/* 'S/L', 'T/P',*/'Close time date', 'Commission', 'Swap', 'Status', 'Comment'],
            rowSelected:["ID","Open Time Date","Type","Reason","Lots","Instrument","Open Price",'Close time date',"Close price","Profit/loss","Swap","T/P","S/L","Commission"],
            reasonList:{
                'C' : "Closed By Trader's order",
                'D' : "Closed By Dealer's order",
                'S' : "Stop-Loss: SL",
                'L' : "Take-Profit: TP",
                'M' : "Margin Call",
                'ME': "Minimal Equity",
                'I' : "Opposite Direction I Order",
                'E' : "Opposite Direction E Order",
                'T' : "Price Changed On C Order",
                'R' : "Price Changed On I Order",
            }
            
        }
    },
    components:{
        appCustomTime:app_custom_time,
        tabSection:tab_section
    },
    props:{
        pageLimit:{
            type: Number,
            default: 5
        },
        order:{
            default: 'history'
        }
    },
    methods:{
        saveLocal(){
            localStorage.setItem('Trade_History_Rows', JSON.stringify(this.rowSelected));
        },
        addRemBodyClass(){
            if($(document.getElementsByClassName('maxCollapse')).hasClass('maximizeToggle')){
                $(document.getElementsByClassName('maxCollapse')).removeClass('maximizeToggle')

                $(document.getElementsByClassName('splitTop')).height('calc(100vh - 290px)')

                if(this.$route.name == 'home'){
                    this.$parent.pageLimit = 5
                }
            }else{
                $(document.getElementsByClassName('maxCollapse')).addClass('maximizeToggle')
                $(document.getElementsByClassName('splitTop')).height(0)
                if(this.$route.name == 'home'){
                    this.$parent.pageLimit = 15
                }
            }
        },
        getQuantity(list){
            let lotBy = ((this.instruments[list.Symbol] || {}).other || {}).Contract_Size || 100000
            try{
                // lotBy = this.currencyPairs.filter(val=>val.isinid.includes( list.Symbol.slice(0,6)))[0].market_ContractSize || lotBy;
                var symbol = (list && list.Symbol) ? list.Symbol : "";
                var foundIsin = (this.currencyPairs && this.currencyPairs.find)
                ? this.currencyPairs.find(function (val) {
                    return val.isinid === symbol || val.isinid === symbol.slice(0, 6);
                    })
                : null;

                lotBy = (foundIsin && foundIsin.market_ContractSize) ? foundIsin.market_ContractSize : 100000;
            }catch(e){}
            if(this.userSettings.position_size && this.userSettings.position_size == '1'){
                return list.Quantity
            }else{
                const qty = list.Quantity?(list.Quantity / lotBy):0;
                return Math.round(qty * 100) / 100;
            }
        },
        changeDate(){
            this.filterOption = false
            if(this.dateSelected == '1'){
                this.FROM_DATE = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.TO_DATE = moment().format('YYYY-MM-DD');
            }else if(this.dateSelected == '2'){
                this.FROM_DATE = moment().subtract(15, 'days').format('YYYY-MM-DD');
                this.TO_DATE = moment().format('YYYY-MM-DD');
            }else if(this.dateSelected == '3'){
                this.FROM_DATE = moment().subtract(1, 'months').format('YYYY-MM-DD');
                this.TO_DATE = moment().format('YYYY-MM-DD');
            }else if(this.dateSelected == '4'){
                this.FROM_DATE = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.TO_DATE = moment().format('YYYY-MM-DD');
            }
            this.rejectedTradeListing()
            this.TradeHistoryListing()
        },
        settingsDate(){
            let history_range = this.userSettings.history_range || ''
            this.filterOption = false
            if(history_range == '1'){
                this.FROM_DATE = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.TO_DATE = moment().format('YYYY-MM-DD');
            }else if(history_range == '2'){
                this.FROM_DATE = moment().subtract(15, 'days').format('YYYY-MM-DD');
                this.TO_DATE = moment().format('YYYY-MM-DD');
            }else if(history_range == '3'){
                this.FROM_DATE = moment().subtract(1, 'months').format('YYYY-MM-DD');
                this.TO_DATE = moment().format('YYYY-MM-DD');
            }else if(history_range == '4'){
                this.FROM_DATE = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.TO_DATE = moment().format('YYYY-MM-DD');
            }
            this.dateSelected = history_range
        },
        tradeTypeChange(){
        	this.page = '1'
            if(this.tradeType != '1' && !this.lastTrade){
                this.lastTrade = true
                this.rejectedTradeListing()
            }
            this.status=false
        },
        rejectedTradeListing(){
            let inputJson = {
                'globalParams' : {
                    'FROM_DATE' : this.FROM_DATE,
                    'TO_DATE' : this.TO_DATE ,
                },
                'localParams' : { 'parameter' : this }
            }
            this._runGetRemovedTradeList(inputJson)
        },
        TradeHistoryListing(){
            let inputJson = {
                'globalParams' : {
                    'FROM_DATE' : this.FROM_DATE,
                    'TO_DATE' : this.TO_DATE ,
                },
                'localParams' : { 'parameter' : this }
            }
            this._runGetTradeHistoryList(inputJson)
        },
        changeTime(){
            this.page = 1;
            this.rejectedTradeListing()
            this.TradeHistoryListing()
            this.customTime = false
            this.dateSelected = ''
        },
        exportCsv() {
            let tradeHistoryType;

            const formatDate = (dateStr) => {
                if (!dateStr) return "";
                const d = new Date(dateStr);
                const date = d.toLocaleDateString("en-GB"); // dd/mm/yyyy
                const time = d.toLocaleTimeString("en-GB", { hour12: false });
                return `${time} - ${date}`;
            };

            const addColumns = (tradeList) =>
                tradeList.map(v => {
                    if (!v || typeof v !== 'object') {
                        console.error('Invalid data in tradeList:', v);
                        return {};
                    }

                    return {
                        "Trade ID": v.TradeID,
                        "Open Time Date": formatDate(v.OpenTime),
                        "Type": v.Side ? "Buy" : "Sell",
                        [this.userSettings.position_size == "1" ? "Units" : "Lots"]: this.getQuantity(v),
                        "Instrument": v.Symbol,
                        "Open Price": v.OpenPrice,
                        "S/L": v.StopLoss || "-",   // if you have StopLoss
                        "T/P": v.TakeProfit || "-", // if you have TakeProfit
                        "Close time date": formatDate(v.CloseTime),
                        "Close price": v.ClosePrice,
                        "Commission": v.Commission || 0,
                        "Swap": v.Interest || 0,
                        "Profit/Loss": v.ProfitLoss,
                        "Status": v.CloseOrderType === "C" ? "Completed" : "Open",
                        "Comment": v.Commentary || "-",
                        "Reason": v.CloseReason || "-" // if you have a field for reason
                    };
                });

            if (this.tradeType == "1") {
                tradeHistoryType = addColumns(this.tradeHistoryList);
            } else if (this.tradeType == "2") {
                tradeHistoryType = addColumns(this.rejectedTradeList);
            } else if (this.tradeType == "3") {
                tradeHistoryType = addColumns(this.pendingTradeList);
            }

            // CSV headers (ordered)
            const headers = Object.keys(tradeHistoryType[0]);
            const csvContent =
                headers.join(",") +
                "\n" +
                tradeHistoryType.map(row => headers.map(h => row[h]).join(",")).join("\n");

            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", "Account_History.csv");
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },
        exportCsv_old() {
            let tradeHistoryType;

            const addColumns = (tradeList) =>
            tradeList.map(v => {
                if (!v || typeof v !== 'object') {
                    console.error('Invalid data in tradeList:', v);
                    return {};
                }
                // Create a copy of the original object and add new properties
                const updatedRow = Object.assign({}, v, {
                    Type: v.Side ? 'Buy' : 'Sell',
                    [this.userSettings.position_size == '1' ? 'Units' : 'Lots']: this.getQuantity(v)
                });

                // Reorder keys: Move Quantity, then add Type and Units/Lots
                const reorderedRow = {};
                for (const key in updatedRow) {
                    if (key === 'Quantity') {
                        // reorderedRow.Quantity = updatedRow.Quantity;
                        reorderedRow.Type = updatedRow.Type;
                        reorderedRow[this.userSettings.position_size == '1' ? 'Units' : 'Lots'] = updatedRow[this.userSettings.position_size == '1' ? 'Units' : 'Lots'];
                    } else if (key !== 'Type' && key !== 'Units' && key !== 'Lots') {
                        reorderedRow[key] = updatedRow[key];
                    }
                }
                return reorderedRow;
            });
            if (this.tradeType == '1') {
                tradeHistoryType = addColumns(this.tradeHistoryList);
            } else if (this.tradeType == '2') {
                tradeHistoryType = addColumns(this.rejectedTradeList);
            } else if (this.tradeType == '3') {
                tradeHistoryType = addColumns(this.pendingTradeList);
            }

            const excludeColumns = ['OpenBalance', 'OpenUsedMargn', 'OpenEquity', 'CloseBalance', 'CloseUsedMargn', 'CloseEquity', 'Side'];
            const headers = Object.keys(tradeHistoryType[0]).filter(column => !excludeColumns.includes(column));
            const csvContent =
                headers.join(',') +
                '\n' +
                tradeHistoryType.map((row) => headers.map((header) => row[header] || '').join(',')).join('\n');

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', 'Account_History.csv');
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    },
    computed:{
        p_l(){
            return this.tradeHistoryList.reduce((total, obj) => {
                return total + (parseFloat(obj.ProfitLoss || 0) - Math.abs(obj.Commission || 0) + parseFloat(obj.Interest));
            }, 0);
        },
        checkWS(){
            let _that = this
            this.tempOrderId.forEach(val=>{
                if(_that.wsOrder.hasOwnProperty(val)){
                    let msg = _that.wsOrder[val].resp_msg
                    let msgType = (_that.wsOrder[val].stat == 'OK')?'success':'error'
                    _that.displayError(msg,msgType)
                    _that.tempOrderId.splice(_that.tempOrderId.indexOf(val), 1)
                }
            })
        },
    	instruments() {
    	    try {                    
	            this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
	            return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
	        } catch (ex) {
	            return {}
	        }
	    },
    },
    created(){
        this.settingsDate()
        if(localStorage.getItem('Trade_History_Rows')){
            let data = JSON.parse(localStorage.getItem('Trade_History_Rows'))
            if(data.length){
                this.rowSelected = data
            }
        }
        if(this.tradeHistoryList.length == 0 || this.tradeHistoryApiCall){
            this.TradeHistoryListing()
        }
    },
    mounted() {
        const _that = this
        $(document).on("click", function(event){
            if(!$(event.target).closest('.customTime').length){
                _that.customTime = false
            }
            if(!$(event.target).closest('.statusChange').length){
                _that.status = false
            }
            if(!$(event.target).closest('.filterOption').length){
                _that.filterOption = false
            }
        });
    }
}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/order/trade-history.vue